export default "__VITE_ASSET__Ddkc6tsJ__"